// src/components/Sitemap.jsx
import React from "react";
import "../css/Sitemap.css";

const Sitemap = () => {
  const primaryLinks = [
    {
      label: "Products",
      className: "sitemap-group",
      children: [
        { label: "All Products", path: "/products" },
        { label: "Flowmeter", path: "/products/1" },
        {
          label: "Regulators",
          path: "/products/2",
          children: [
            { label: "Ingage Regulator", path: "/products/6" },
            { label: "RW Regulator", path: "/products/6" },
            { label: "Pressure Reducer", path: "/products/3" },
          ],
        },
        { label: "Mass Casualty", path: "/products/4" },
        { label: "Transfill Cascade", path: "/products/5" },
        { label: "Fittings / Accessories / Replacement Parts", path: "/products/fittings" },
        { label: "EMS", path: "/products/ems" },
      ],
    },
    {
      label: "Support",
      className: "sitemap-group",
      children: [
        { label: "FAQ", path: "/faq" },
        { label: "Contact", path: "/contact" },
        { label: "Ordering & Returns", path: "/PDF's_Frequently_Asked_Questions/Form%20RMA%20Info%20Rev%202.pdf" },
        { label: "Internet and Privacy Policy", path: "/PDF's_Frequently_Asked_Questions/M-Internet_Privacy_Policy(2014-12-01).docx.pdf" },
        { label: "Sales Terms", path: "/PDF's_Frequently_Asked_Questions/M-Sales%20Terms%20(2018-09-10).docx.pdf" },
        { label: "Product Warranty", path: "/PDF's_Frequently_Asked_Questions/M-Warranty%20(2024-05-06)%20(Rev.%20A).docx.pdf" },
        { label: "Sitemap", path: "/sitemap" },
      ],
    },
    {
      label: "About",
      className: "sitemap-group",
      children: [
        { label: "Our Story", path: "/PDF's_About_Flotec/B-About%20Flotec%20(2024-06-16)%20(Rev.%20B).docx.pdf" },
      ],
    },
  ];

const secondaryLinks = [
  {
    label: "Instructions for Use (IFUs)",
    className: "sitemap-group",
    children: [
        { label: "Flowmeter IFU", path: "/IFU/IFU%20Flowmeter%20Rev%20H%20(NO%20CE%20MARK).pdf" },
        { label: "Ingage Regulator IFU", path: "/IFU/IFU%20InGage%20Regulator%20Rev%20G%20(NO%20CE%20MARK).pdf" },
        { label: "RW Regulator IFU", path: "/IFU/IFU%20RW%20Regulator%20Rev%20G%20(NO%20CE%20MARK).pdf" },
        { label: "Pressure Reducer IFU", path: "/IFU/IFU-Hose%20Assembly%20-%20Canadian%20Standard%20Rev%20B.pdf" },
        { label: "Mass Casualty IFU", path: "/IFU/IFU%20Mass%20Casualty%20Assembly%20Rev%20H%20(NO%20CE%20MARK).pdf" },
        { label: "Transfill Cascade IFU", path: "/IFU/IFU-Transfill%20Cascade%20System%20(2023-12-13)%20(Rev.%20A).docx.pdf" },
        { label: "Hose Assembly Rev. A", path: "/IFU/IFU-Hose%20Assembly%20Rev%20A.pdf" },
        { label: "Multilatorr Rev. A", path: "/IFU/IFU-Multilatorr%20(2023-12-29)%20(Rev.%20A).docx.pdf" },
        { label: "Regulator-C3F8 Rev. C", path: "/IFU/IFU-Regulator-C3F8%20Rev%20C.pdf" },
        { label: "Regulator-SF6 Rev. C", path: "/IFU/IFU-Regulator-SF6%20Rev%20C.pdf" },
        { label: "Regulator-Smiths Rev. C", path: "/IFU/IFU-Regulator-Smiths%20Rev%20C.pdf" },
        { label: "Regulator-TestKit Rev. B", path: "/IFU/IFU-Regulator-TestKit%20Rev%20B.pdf" },
        { label: "Resident-Nipple-Adapter Rev. A", path: "/IFU/IFU-Resident-Nipple-Adapter%20Rev%20A.pdf" },
        { label: "TOAD Rev A", path: "/IFU/IFU-TOAD%20Rev%20A.pdf" },
        ],
    },
  {
    label: "Brochures",
    className: "sitemap-group",
    children: [
        { label: "Ambulance Respiratory Systems (DL) Rev. B", path: "/BROCHURES/B-Ambulance%20Respiratory%20Systems%20(DL)%20(2024-06-10)%20(Rev.%20B).docx.pdf" },
        { label: "Ambulance Respiratory Systems (RW) Rev. B", path: "/BROCHURES/B-Ambulance%20Respiratory%20Systems%20(RW)%20(2024-06-10)%20(Rev.%20B).docx.pdf" },
        { label: "Flowmeter Rev. B", path: "/BROCHURES/B-Flowmeter%20(2024-05-14)%20(Rev.%20B).docx.pdf" },
        { label: "Mass Casualty Assembly Rev. A", path: "/BROCHURES/B-Mass%20Casualty%20Assembly%20(2024-02-05)%20(Rev.%20A).docx.pdf" },
        { label: "Medical Gas Fittings & Accessories Rev. B", path: "/BROCHURES/B-Medical%20Gas%20Fittings%20and%20Accessories%20(2024-02-12)%20(Rev.%20B).docx.pdf" },
        { label: "Regulator, InGage Rev. A", path: "/BROCHURES/B-Regulator,%20InGage%20(2024-05-21)%20(Rev.%20A).docx.pdf" },
        { label: "Transfill Cascade System Rev. D", path: "/BROCHURES/B-Transfill%20Cascade%20System%20(2025-04-24)%20(Rev.%20D).docx.pdf" },
        { label: "Hose Assembly Cover & Code Rev. B", path: "/BROCHURES/B-Hose%20Assembly%20Cover%20and%20Code%20(HA)%20(2025-11-28)%20(Rev.%20B).pdf" },
    ],
  },
];

 const renderLinks = (links) => (
  <ul>
    {links.map((link) => (
      <li key={link.path || link.label} className={link.className || ""}>
        {link.path ? <a href={link.path}>{link.label}</a> : link.label}
        {link.children && renderLinks(link.children)}
      </li>
    ))}
  </ul>
);

  return (
    <div className="sitemap-wrapper">
      <h1 className="sitemap-header">Sitemap</h1>
      <hr className="sitemap-divider" />

      
      <div className="sitemap-columns">
        {/* Primary Column */}
        <div className="sitemap-column">
          <h2>Primary</h2>
          {renderLinks(primaryLinks)}
        </div>

        {/* Secondary Column */}
        <div className="sitemap-column">
          <h2>Secondary</h2>
          {renderLinks(secondaryLinks)}
        </div>
      </div>
    </div>
  );
};

export default Sitemap;
